import queryString from "query-string";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useHistory } from "react-router-dom";
import TabPanel from "../../elements/tab/materialTabPanel";
import { useTranslation } from "react-i18next";
import SystemLogsContainer from "./systemLogs/LogsContainer";
import ServiceLogsContainer from "./serviceLogs/LogsContainer";

import { StyledTabsBody, StyledTabsHead, StyledTabsWrapper } from "../../styles/styledTabs";

const DEFAULT_TAB = "system";

const LogsTabsContainer = () => {
  const { t } = useTranslation("logsPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "system": {
        return 0;
      }
      case "service": {
        return 1;
      }
    }

    return 0;
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };
  return (
    <>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledTabsWrapper>
        <StyledTabsHead className="tab-head">
          <h4 className="tab-head__title">
            {t("tabs.title")}
          </h4>
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="vertical"
            className="tab-head-buttons"
          >
            <Tab label={t("tabs.systemLogs")} value="system" />
            <Tab label={t("tabs.serviceLogs")} value="service" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <SystemLogsContainer t={t}/>
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
          >
            <ServiceLogsContainer t={t}/>
          </TabPanel>
        </StyledTabsBody>
      </StyledTabsWrapper>
    </>
  );
};

export default LogsTabsContainer;